// The LIVE, already-computed analytics values — `getAnalyticsResult()`.
//
// Unlike `projectAppsByAppID` (a synchronous broadcast state key, read via
// `readState`), this is an ASYNC RPC CALL — Giraffe computes it on demand, not
// something it broadcasts. The shape itself (confirmed real, not guessed —
// see data/analyticsTypes.ts's own header) lives in data/ so the pure data
// layer never has to import this file or the SDK it pulls in; this file is
// just the fetch.

import { invoke } from './adapter';
import type { AnalyticsDataRoot } from '@/data/analyticsTypes';

export type {
  AnalyticsDataRoot,
  AnalyticsRow,
  AnalyticsColumn,
  AnalyticsMeasure,
  AnalyticsComponent,
  AnalyticsCombined,
  AnalyticsGroup,
  AnalyticsUnitTotalItem,
} from '@/data/analyticsTypes';
export { analyticsRows, columnKey, columnLabel } from '@/data/analyticsTypes';

/** `null` on any failure (including "no analytics template exists yet") — the same as Cashflow's own `catch`. */
export async function getAnalyticsResult(): Promise<AnalyticsDataRoot | null> {
  const res = await invoke<AnalyticsDataRoot>('getAnalyticsResult', [], 15000);
  return res.ok ? res.value : null;
}
